import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatDate, formatCurrency, formatBoolean } from "../SheetLayout";

const GastosJuridico: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const gastoJuridicoId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getLegalExpenses, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getLegalExpenses(userId, prestacionId, gastoJuridicoId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Gasto Jurídico"
        icon="briefcase"
        pills={<>
          <SheetPill label="Tipo" value={formatText(d.tipoGastoJuridicoDescripcion)} />
          <SheetPill label="Pagado" value={formatBoolean(d.estaPagado)} />
        </>}
      />

      <SheetSection title="Datos Gasto Jurídico" icon="file-text">
        <SheetGrid>
          <SheetField label="Tipo de Gasto General"  value={formatText(d.tipoGastoGeneralDescripcion)} wide />
          <SheetField label="Tipo de Gasto Jurídico" value={formatText(d.tipoGastoJuridicoDescripcion)} wide />
          <SheetField label="Parte Empresa"          value={formatText(d.parteEmpresa)} />
          <SheetField label="Parte Solimat"          value={formatText(d.parteSolimat)} />
          <SheetField label="Fianza"                 value={formatText(d.fianza)} />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Resolución" icon="check-circle">
        <SheetGrid>
          <SheetField label="Pagado"                  value={formatBoolean(d.estaPagado)} />
          <SheetField label="Fecha Pago"              value={formatDate(d.fechaPago)} />
          <SheetField label="Fecha Traspaso a Banco"  value={formatDate(d.fechaTraspasoABanco)} />
          <SheetField label="Cuantía Económica Neto"  value={formatCurrency(d.neto)} />
          <SheetField label="Tasa"                    value={formatText(d.tasa)} />
        </SheetGrid>
      </SheetSection>
    </SheetPage>
  );
};

export default GastosJuridico;
